import { render, staticRenderFns } from "./DistributionRegisterPage.vue?vue&type=template&id=0c3ac880&scoped=true"
import script from "./DistributionRegisterPage.vue?vue&type=script&lang=js"
export * from "./DistributionRegisterPage.vue?vue&type=script&lang=js"
import style0 from "./DistributionRegisterPage.vue?vue&type=style&index=0&id=0c3ac880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ac880",
  null
  
)

export default component.exports